class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
        this.addYampiButtonListener(); // Adiciona o listener para o botão da Yampi
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  addYampiButtonListener() {
    var yampiCheckoutButton = document.getElementById('ympBtn');
    if (yampiCheckoutButton) {
      console.log('Yampi button found');
      yampiCheckoutButton.addEventListener('click', function(event) {
        event.preventDefault();
        console.log('Yampi button clicked');
        yampiClick();
      });
    } else {
      console.log('Yampi button not found');
    }
  }
}

customElements.define('mini-cart', MiniCart);

document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM fully loaded and parsed');
  var miniCartElement = document.querySelector('mini-cart');
  if (miniCartElement) {
    miniCartElement.addYampiButtonListener();
  }
});

function yampiClick() {
  console.log('Executing yampiClick function');
  showYampiLoader();

  getAjax('/cart.json', function(response) {
    console.log('Cart data fetched');
    var cartPayload = JSON.parse(response);

    var data = {
      shop: window.location.host,
      cart_payload: cartPayload
    };

    postAjax('https://api.dooki.com.br/v2/public/shopify/cart', JSON.stringify(data), function(response) {
      var resp = JSON.parse(response);
      console.log('Redirecting to Yampi checkout URL:', resp.checkout_direct_url);
      window.location.href = ymp_getUrlWithUtms(resp.checkout_direct_url);
    });
  });
}

function showYampiLoader() {
  var el = document.querySelector('.yampi-loader');
  if (el) {
    el.style.display = 'block';
  }
}

function hideYampiLoader() {
  var el = document.querySelector('.yampi-loader');
  if (el) {
    el.style.display = 'none';
  }
}

function getAjax(url, success) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url);
  xhr.onreadystatechange = function() {
    if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
  };
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.send();
}

function postAjax(url, data, success) {
  var params = typeof data == 'string' ? data : Object.keys(data).map(
    function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
  ).join('&');

  var xhr = new XMLHttpRequest();
  xhr.open('POST', url);
  xhr.onreadystatechange = function() {
    if (xhr.readyState > 3 && xhr.status == 200) { success(xhr.responseText); }
  };
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send(params);
  return xhr;
}

function ymp_getUrlWithUtms(url) {
  if (!url) return url;

  var currentUrl = new URL(url);
  var _ga = ymp_getCookie('_ga');
  var cookiesUtms = ymp_getUtms();

  cookiesUtms.forEach(function(value, key) {
    currentUrl.searchParams.set(key, value);
  });

  if (_ga) {
    currentUrl.searchParams.set('_ga', _ga);
  }

  return currentUrl.href;
}

function ymp_getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function ymp_getUtms() {
  var currentUtms = ymp_getCookie('utmsTrack');
  if (currentUtms) {
    return new URLSearchParams(currentUtms);
  }
  return new URLSearchParams();
}
